import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ilustrations/deletar-conta.gif'


const _withScopeId = n => (_pushScopeId("data-v-bba2be9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "256",
  width: "256"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "content" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Exclusão de conta"),
  /*#__PURE__*/_createElementVNode("p", null, "A exclusão da conta tem efeito imediato e irreversível, prossiga com cautela."),
  /*#__PURE__*/_createElementVNode("p", null, "Ao excluir a sua conta, todas as suas informações fornecidas para login e outras relacionadas ao seu usuário serão removidas do aplicativo, o que também resultará em você ser redirecionada para a tela de login."),
  /*#__PURE__*/_createElementVNode("p", null, "Para prosseguir com a exclusão da sua conta, é necessário que você remova todos os itens da sua lista de compras e tenha feito login recentemente.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("article", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_Button, {
      disabled: _ctx.disableButtons,
      "button-text": 'Fazer login novamente',
      "has-icon": 'No',
      onClick: _ctx.handleReauthentication
    }, null, 8, ["disabled", "onClick"]),
    _createVNode(_component_Button, {
      disabled: _ctx.disableButtons,
      id: "deleteAccount",
      "button-text": 'Solicitar exclusão da conta',
      "has-icon": 'No',
      onClick: _ctx.handleDeleteButton
    }, null, 8, ["disabled", "onClick"])
  ]))
}